import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { confirmDiscardChanges } from '../../Hooks/useUnsavedChangesGuard';

interface DiscardButtonProps {
    to?: string;
    onClick?: () => void;
    iconOnly?: boolean;
    className?: string;
    disabled?: boolean;
    /** When true, warns before discarding unsaved changes. */
    isDirty?: boolean;
}

const DiscardButton: React.FC<DiscardButtonProps> = ({ to, onClick, iconOnly = false, className, disabled = false, isDirty = false }) => {
    const guardedOnClick = () => {
        if (isDirty && !confirmDiscardChanges()) return;
        onClick?.();
    };

    const btn = (
        <button
            type="button"
            disabled={disabled}
            onClick={to ? undefined : guardedOnClick}
            className={`st-btn st-btn--outline${iconOnly ? ' st-btn--icon' : ''}${className ? ` ${className}` : ''}`}
        >
            <FontAwesomeIcon icon={faTimes} />
            {!iconOnly && <span>Zrušiť</span>}
        </button>
    );

    return to && !disabled ? (
        <Link
            to={to}
            className="text-decoration-none"
            onClick={e => { if (isDirty && !confirmDiscardChanges()) e.preventDefault(); }}
        >{btn}</Link>
    ) : btn;
};

export default DiscardButton;
